

/* tslint:disable */



export enum PublicLinkSortBy {
    Default = 1,
    CreatedBy = 2,
    CreatedAt = 3,

}


